import { render, staticRenderFns } from "./Sports.vue?vue&type=template&id=5c9880ce&scoped=true"
import script from "./Sports.vue?vue&type=script&setup=true&lang=js"
export * from "./Sports.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Sports.vue?vue&type=style&index=0&id=5c9880ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9880ce",
  null
  
)

export default component.exports